import { DndContext, type DragEndEvent, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { rectSortingStrategy, SortableContext } from '@dnd-kit/sortable';
import React from 'react';
import { reorderByDragEnd } from '../../utils/reorderByDragEnd';
import SortableChip from './SortableChip';
import { SortableChipsProps } from './types';

export const SortableChips = ({
    chips,
    getTagProps,
    fixedOptions,
    onReorder,
    getChipKey,
    getChipSx,
    onChipClick
}: SortableChipsProps) => {
    const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));
    const chipIds = chips.map((chip, index) => getChipKey?.(chip, index) || chip.id || chip.label || `chip-${index}`);

    const handleDragEnd = (event: DragEndEvent) => {
        const reordered = reorderByDragEnd(event, chips, chipIds);
        if (!reordered) {
            return;
        }
        onReorder(reordered);
    };

    return (
        <DndContext sensors={sensors} onDragEnd={handleDragEnd}>
            <SortableContext items={chipIds} strategy={rectSortingStrategy}>
                {chips.map((chip, index) => (
                    <SortableChip
                        key={chipIds[index]}
                        chip={chip}
                        chipId={chipIds[index]}
                        tagProps={getTagProps({ index })}
                        isFixed={fixedOptions.includes(chip.label)}
                        chipSx={getChipSx?.(chipIds[index])}
                        onChipClick={onChipClick}
                    />
                ))}
            </SortableContext>
        </DndContext>
    );
};
